import React from 'react';
import trackingService, { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import styles from './LinkButton.module.scss';

interface ITextButtonProps {
    title: string;
    onClick?: () => void;
    testId?: string;
    track: TrackingEvent;
}

const TextButton: React.FC<ITextButtonProps> = (props: ITextButtonProps) => {
    const handleClick = () => {
        if (props.onClick) {
            props.onClick();
        }
        trackingService.track(props.track);
    };

    return (
        <span className={styles.text_button} onClick={handleClick} data-testid={props.testId} role="button" onKeyPress={() => {}} tabIndex={0}>
            {props.title}
        </span>
    );
};

export default TextButton;
